import Transition from "../pages/Transition/Transition";
import FindGraduateSchools from "../pages/FindGraduateSchools/FindGraduateSchools";
import GetResearchExperience from "../pages/GetResearchExperience/GetResearchExperience";
import ExploreCareers from "../pages/ExploreCareers/ExploreCareers";
import TalkToAnExpert from "../pages/TalkToAnExpert/TalkToAnExpert";
import FindInternships from "../pages/FindInternships/FindInternships";
import Bookmarks from "../pages/Bookmarks/Bookmarks";
import LogoutRoute from "../pages/RecommenderPage/LogoutRoute";
import {
  ContentPageRoute,
  MentorPalRoute,
  RecommenderPageRoute,
} from "./routeElements";

export function sharedRoutes() {
  return [
    {
      index: true,
      element: <ContentPageRoute />,
    },
    {
      path: "mentorpal",
      element: <MentorPalRoute />,
    },
    {
      path: "transition",
      element: <Transition />,
    },
    {
      path: "logout",
      element: <LogoutRoute />,
    },
    {
      path: "recommenderpage",
      element: <RecommenderPageRoute />,
      children: [
        {
          index: true,
          element: <FindGraduateSchools />,
        },
        {
          path: "get-research-experience",
          element: <GetResearchExperience />,
        },
        {
          path: "explore-careers",
          element: <ExploreCareers />,
        },
        {
          path: "find-graduate-schools",
          element: <FindGraduateSchools />,
        },
        {
          path: "talk-to-an-expert",
          element: <TalkToAnExpert />,
        },
        {
          path: "find-internships",
          element: <FindInternships />,
        },
        {
          path: "bookmarks",
          element: <Bookmarks />,
        },
      ],
    },
  ];
}
